// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kot-player-result__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 10000;
  padding: 0;
}

@media (min-width: 600px) {
  .kot-player-result__backdrop {
    align-items: center;
    padding: 24px;
  }
}

.kot-player-result__sheet {
  background: #ffffff;
  width: 100%;
  max-width: 600px;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  min-height: 70vh;
  max-height: 90vh;
}

@media (min-width: 600px) {
  .kot-player-result__sheet {
    border-radius: 24px;
    min-height: 600px;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.kot-player-result__close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: #f5f5f5;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}

.kot-player-result__close:active {
  background: #e0e0e0;
  transform: scale(0.9);
}

.kot-player-result__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 1;
}

.kot-player-result__header {
  padding: 24px 24px 16px;
  text-align: center;
}

.kot-player-result__title {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 800;
  color: #1a1a1a;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.kot-player-result__progress {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.kot-player-result__step {
  height: 6px;
  width: 40px;
  border-radius: 3px;
  background: #e0e0e0;
  transition: all 0.3s ease;
}

.kot-player-result__step.active {
  background: var(--brand-primary, #0877bc);
  width: 60px;
}

.kot-player-result__step.completed {
  background: var(--brand-primary, #0877bc);
  opacity: 0.6;
}

.kot-player-result__body {
  padding: 0 24px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.kot-player-result__instruction {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 32px;
}

/* VS Cards Step */
.kot-player-result__vs-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 16px;
  margin-bottom: 40px;
}

.kot-player-result__card {
  flex: 1 1;
  background: #f8f9fa;
  border: 3px solid #e0e0e0;
  border-radius: 20px;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-height: 200px;
}

.kot-player-result__card:active {
  transform: scale(0.95);
}

.kot-player-result__card.selected {
  border-color: #4caf50;
  background: #f1f8e9;
  box-shadow: 0 8px 24px rgba(76, 175, 80, 0.25);
  transform: scale(1.05);
  z-index: 2;
}

.kot-player-result__card-icon {
  height: 48px;
  margin-bottom: 16px;
  color: #ffb300;
}

.kot-player-result__card-icon svg {
  font-size: 48px;
  filter: drop-shadow(0 2px 4px rgba(255, 179, 0, 0.4));
  animation: popIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes popIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.kot-player-result__card-name {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  text-align: center;
  word-break: break-word;
  line-height: 1.2;
}

.kot-player-result__vs-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #333;
  color: #fff;
  font-weight: 900;
  font-size: 18px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border: 4px solid #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Score Step */
.kot-player-result__score-input {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 40px;
}

.kot-player-result__score-btn {
  background: #f0f0f0;
  border: none;
  width: 80px;
  height: 80px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.kot-player-result__score-btn svg {
  font-size: 40px;
}

.kot-player-result__score-btn.minus {
  color: #f44336;
}

.kot-player-result__score-btn.plus {
  color: #4caf50;
}

.kot-player-result__score-btn:active {
  transform: scale(0.9);
  background: #e0e0e0;
}

.kot-player-result__score-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
}

.kot-player-result__score-value {
  font-size: 80px;
  font-weight: 800;
  line-height: 1;
  color: #1a1a1a;
  font-variant-numeric: tabular-nums;
}

.kot-player-result__score-label {
  font-size: 16px;
  font-weight: 600;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.kot-player-result__summary {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 24px;
  gap: 16px;
}

.kot-player-result__summary-player {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
}

.kot-player-result__summary-player.winner {
  color: #2e7d32;
}

.kot-player-result__summary-player.loser {
  color: #555;
}

.kot-player-result__summary-player .score {
  font-size: 24px;
  font-weight: 800;
  background: rgba(0, 0, 0, 0.05);
  padding: 4px 12px;
  border-radius: 8px;
}

.kot-player-result__summary-divider {
  font-size: 24px;
  font-weight: 800;
  color: #ccc;
}

.kot-player-result__golden-point {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 20px;
  border-radius: 16px;
  background: #fff;
  border: 2px solid #e0e0e0;
  font-size: 18px;
  font-weight: 700;
  color: #555;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 24px;
}

.kot-player-result__golden-point svg {
  font-size: 28px;
  color: #999;
  transition: color 0.2s ease;
}

.kot-player-result__golden-point.active {
  background: #fff8e1;
  border-color: #ffc107;
  color: #f57f17;
}

.kot-player-result__golden-point.active svg {
  color: #ffb300;
}

.kot-player-result__golden-point:active {
  transform: scale(0.98);
}

.kot-player-result__error {
  background: #ffebee;
  color: #c62828;
  padding: 16px;
  border-radius: 12px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
  animation: slideUp 0.3s ease;
}

.kot-player-result__footer {
  padding: 24px;
  display: flex;
  gap: 16px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.kot-player-result__btn-back {
  flex: 1 1;
  padding: 20px;
  background: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease;
}

.kot-player-result__btn-back:active {
  background: #e0e0e0;
}

.kot-player-result__btn-submit {
  flex: 2 1;
  padding: 20px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 16px;
  font-size: 20px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.4);
}

.kot-player-result__btn-submit:disabled {
  background: #a5d6a7;
  box-shadow: none;
  cursor: not-allowed;
}

.kot-player-result__btn-submit:not(:disabled):active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4);
}

/* Success Animation State */
.kot-player-result__sheet--success {
  background: #4caf50;
  transition: background 0.4s ease;
}

.kot-player-result__success-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: white;
  animation: fadeIn 0.4s ease;
}

.kot-player-result__success-icon {
  font-size: 120px !important;
  margin-bottom: 24px;
  animation: scalePop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.kot-player-result__success-text {
  font-size: 32px;
  font-weight: 800;
  text-align: center;
  margin: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scalePop {
  0% { transform: scale(0); opacity: 0; }
  70% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); }
}

/* Landscape phones — fit wizard inside viewport without clipping */
@media (orientation: landscape) {
  .kot-player-result__backdrop {
    align-items: center;
    padding: max(6px, env(safe-area-inset-top)) max(10px, env(safe-area-inset-right))
      max(6px, env(safe-area-inset-bottom)) max(10px, env(safe-area-inset-left));
  }

  .kot-player-result__sheet {
    min-height: unset;
    max-height: calc(100dvh - 12px);
    max-width: min(640px, 94vw);
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .kot-player-result__content {
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .kot-player-result__header {
    padding: 10px 40px 6px 14px;
    flex-shrink: 0;
  }

  .kot-player-result__title {
    margin: 0 0 6px;
    font-size: 15px;
    letter-spacing: 0.5px;
  }

  .kot-player-result__step {
    height: 4px;
    width: 32px;
  }

  .kot-player-result__step.active {
    width: 48px;
  }

  .kot-player-result__body {
    padding: 0 14px;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    justify-content: flex-start;
  }

  .kot-player-result__instruction {
    font-size: 14px;
    margin: 0 0 10px;
  }

  .kot-player-result__vs-container {
    margin-bottom: 8px;
    gap: 8px;
  }

  .kot-player-result__card {
    min-height: 72px;
    padding: 10px 8px;
    border-radius: 14px;
    border-width: 2px;
  }

  .kot-player-result__card-icon {
    height: 28px;
    margin-bottom: 6px;
  }

  .kot-player-result__card-icon svg {
    font-size: 28px;
  }

  .kot-player-result__card-name {
    font-size: 13px;
  }

  .kot-player-result__vs-badge {
    width: 32px;
    height: 32px;
    font-size: 11px;
    border-width: 3px;
  }

  .kot-player-result__score-input {
    gap: 10px;
    margin-bottom: 10px;
  }

  .kot-player-result__score-btn {
    width: 52px;
    height: 52px;
    border-radius: 14px;
  }

  .kot-player-result__score-btn svg {
    font-size: 26px;
  }

  .kot-player-result__score-display {
    width: 72px;
  }

  .kot-player-result__score-value {
    font-size: 44px;
  }

  .kot-player-result__score-label {
    font-size: 11px;
  }

  .kot-player-result__summary {
    padding: 8px 10px;
    margin-bottom: 8px;
    gap: 8px;
    border-radius: 12px;
  }

  .kot-player-result__summary-player {
    font-size: 13px;
    gap: 6px;
  }

  .kot-player-result__summary-player .score {
    font-size: 18px;
    padding: 2px 8px;
  }

  .kot-player-result__summary-divider {
    font-size: 18px;
  }

  .kot-player-result__golden-point {
    padding: 10px 12px;
    margin-bottom: 8px;
    font-size: 13px;
    border-radius: 12px;
  }

  .kot-player-result__golden-point svg {
    font-size: 22px;
  }

  .kot-player-result__error {
    padding: 10px;
    margin-bottom: 8px;
    font-size: 13px;
  }

  .kot-player-result__footer {
    padding: 10px 14px;
    gap: 8px;
    flex-shrink: 0;
  }

  .kot-player-result__btn-back,
  .kot-player-result__btn-submit {
    padding: 12px;
    font-size: 14px;
    border-radius: 12px;
  }

  .kot-player-result__close {
    top: 8px;
    right: 8px;
    width: 34px;
    height: 34px;
  }

  .kot-player-result__close svg {
    font-size: 20px;
  }
}

@media (orientation: landscape) and (max-height: 420px) {
  .kot-player-result__sheet {
    max-height: calc(100dvh - 8px);
  }

  .kot-player-result__instruction {
    font-size: 12px;
    margin-bottom: 6px;
  }

  .kot-player-result__card {
    min-height: 58px;
    padding: 8px 6px;
  }

  .kot-player-result__card-name {
    font-size: 12px;
  }

  .kot-player-result__score-btn {
    width: 44px;
    height: 44px;
  }

  .kot-player-result__score-value {
    font-size: 36px;
  }

  .kot-player-result__footer {
    padding: 8px 12px;
  }

  .kot-player-result__btn-back,
  .kot-player-result__btn-submit {
    padding: 10px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/KotPlayerResultDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,+DAA+D;EAC/D,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6DAA6D;EAC7D,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAC9C,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,MAAM,qBAAqB,EAAE,UAAU,EAAE;EACzC,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,mEAAmE;AACnE;EACE;IACE,mBAAmB;IACnB;gFAC4E;EAC9E;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".kot-player-result__backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  z-index: 10000;\n  padding: 0;\n}\n\n@media (min-width: 600px) {\n  .kot-player-result__backdrop {\n    align-items: center;\n    padding: 24px;\n  }\n}\n\n.kot-player-result__sheet {\n  background: #ffffff;\n  width: 100%;\n  max-width: 600px;\n  border-radius: 24px 24px 0 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.15);\n  animation: slideUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  min-height: 70vh;\n  max-height: 90vh;\n}\n\n@media (min-width: 600px) {\n  .kot-player-result__sheet {\n    border-radius: 24px;\n    min-height: 600px;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.kot-player-result__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: #f5f5f5;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #555;\n  cursor: pointer;\n  z-index: 10;\n  transition: all 0.2s ease;\n}\n\n.kot-player-result__close:active {\n  background: #e0e0e0;\n  transform: scale(0.9);\n}\n\n.kot-player-result__content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  flex: 1;\n}\n\n.kot-player-result__header {\n  padding: 24px 24px 16px;\n  text-align: center;\n}\n\n.kot-player-result__title {\n  margin: 0 0 16px;\n  font-size: 24px;\n  font-weight: 800;\n  color: #1a1a1a;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.kot-player-result__progress {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.kot-player-result__step {\n  height: 6px;\n  width: 40px;\n  border-radius: 3px;\n  background: #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n.kot-player-result__step.active {\n  background: var(--brand-primary, #0877bc);\n  width: 60px;\n}\n\n.kot-player-result__step.completed {\n  background: var(--brand-primary, #0877bc);\n  opacity: 0.6;\n}\n\n.kot-player-result__body {\n  padding: 0 24px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.kot-player-result__instruction {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 32px;\n}\n\n/* VS Cards Step */\n.kot-player-result__vs-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  gap: 16px;\n  margin-bottom: 40px;\n}\n\n.kot-player-result__card {\n  flex: 1;\n  background: #f8f9fa;\n  border: 3px solid #e0e0e0;\n  border-radius: 20px;\n  padding: 32px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  min-height: 200px;\n}\n\n.kot-player-result__card:active {\n  transform: scale(0.95);\n}\n\n.kot-player-result__card.selected {\n  border-color: #4caf50;\n  background: #f1f8e9;\n  box-shadow: 0 8px 24px rgba(76, 175, 80, 0.25);\n  transform: scale(1.05);\n  z-index: 2;\n}\n\n.kot-player-result__card-icon {\n  height: 48px;\n  margin-bottom: 16px;\n  color: #ffb300;\n}\n\n.kot-player-result__card-icon svg {\n  font-size: 48px;\n  filter: drop-shadow(0 2px 4px rgba(255, 179, 0, 0.4));\n  animation: popIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n@keyframes popIn {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n.kot-player-result__card-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: #333;\n  text-align: center;\n  word-break: break-word;\n  line-height: 1.2;\n}\n\n.kot-player-result__vs-badge {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #333;\n  color: #fff;\n  font-weight: 900;\n  font-size: 18px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  border: 4px solid #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Score Step */\n.kot-player-result__score-input {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n.kot-player-result__score-btn {\n  background: #f0f0f0;\n  border: none;\n  width: 80px;\n  height: 80px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.kot-player-result__score-btn svg {\n  font-size: 40px;\n}\n\n.kot-player-result__score-btn.minus {\n  color: #f44336;\n}\n\n.kot-player-result__score-btn.plus {\n  color: #4caf50;\n}\n\n.kot-player-result__score-btn:active {\n  transform: scale(0.9);\n  background: #e0e0e0;\n}\n\n.kot-player-result__score-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n}\n\n.kot-player-result__score-value {\n  font-size: 80px;\n  font-weight: 800;\n  line-height: 1;\n  color: #1a1a1a;\n  font-variant-numeric: tabular-nums;\n}\n\n.kot-player-result__score-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: #777;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.kot-player-result__summary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 16px;\n  padding: 16px;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.kot-player-result__summary-player {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.kot-player-result__summary-player.winner {\n  color: #2e7d32;\n}\n\n.kot-player-result__summary-player.loser {\n  color: #555;\n}\n\n.kot-player-result__summary-player .score {\n  font-size: 24px;\n  font-weight: 800;\n  background: rgba(0, 0, 0, 0.05);\n  padding: 4px 12px;\n  border-radius: 8px;\n}\n\n.kot-player-result__summary-divider {\n  font-size: 24px;\n  font-weight: 800;\n  color: #ccc;\n}\n\n.kot-player-result__golden-point {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  padding: 20px;\n  border-radius: 16px;\n  background: #fff;\n  border: 2px solid #e0e0e0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #555;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 24px;\n}\n\n.kot-player-result__golden-point svg {\n  font-size: 28px;\n  color: #999;\n  transition: color 0.2s ease;\n}\n\n.kot-player-result__golden-point.active {\n  background: #fff8e1;\n  border-color: #ffc107;\n  color: #f57f17;\n}\n\n.kot-player-result__golden-point.active svg {\n  color: #ffb300;\n}\n\n.kot-player-result__golden-point:active {\n  transform: scale(0.98);\n}\n\n.kot-player-result__error {\n  background: #ffebee;\n  color: #c62828;\n  padding: 16px;\n  border-radius: 12px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 24px;\n  animation: slideUp 0.3s ease;\n}\n\n.kot-player-result__footer {\n  padding: 24px;\n  display: flex;\n  gap: 16px;\n  background: #fff;\n  border-top: 1px solid #f0f0f0;\n}\n\n.kot-player-result__btn-back {\n  flex: 1;\n  padding: 20px;\n  background: #f0f0f0;\n  color: #333;\n  border: none;\n  border-radius: 16px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.kot-player-result__btn-back:active {\n  background: #e0e0e0;\n}\n\n.kot-player-result__btn-submit {\n  flex: 2;\n  padding: 20px;\n  background: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 16px;\n  font-size: 20px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.4);\n}\n\n.kot-player-result__btn-submit:disabled {\n  background: #a5d6a7;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.kot-player-result__btn-submit:not(:disabled):active {\n  transform: scale(0.98);\n  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4);\n}\n\n/* Success Animation State */\n.kot-player-result__sheet--success {\n  background: #4caf50;\n  transition: background 0.4s ease;\n}\n\n.kot-player-result__success-overlay {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: white;\n  animation: fadeIn 0.4s ease;\n}\n\n.kot-player-result__success-icon {\n  font-size: 120px !important;\n  margin-bottom: 24px;\n  animation: scalePop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.kot-player-result__success-text {\n  font-size: 32px;\n  font-weight: 800;\n  text-align: center;\n  margin: 0;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes scalePop {\n  0% { transform: scale(0); opacity: 0; }\n  70% { transform: scale(1.1); opacity: 1; }\n  100% { transform: scale(1); }\n}\n\n/* Landscape phones — fit wizard inside viewport without clipping */\n@media (orientation: landscape) {\n  .kot-player-result__backdrop {\n    align-items: center;\n    padding: max(6px, env(safe-area-inset-top)) max(10px, env(safe-area-inset-right))\n      max(6px, env(safe-area-inset-bottom)) max(10px, env(safe-area-inset-left));\n  }\n\n  .kot-player-result__sheet {\n    min-height: unset;\n    max-height: calc(100dvh - 12px);\n    max-width: min(640px, 94vw);\n    border-radius: 16px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .kot-player-result__content {\n    min-height: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .kot-player-result__header {\n    padding: 10px 40px 6px 14px;\n    flex-shrink: 0;\n  }\n\n  .kot-player-result__title {\n    margin: 0 0 6px;\n    font-size: 15px;\n    letter-spacing: 0.5px;\n  }\n\n  .kot-player-result__step {\n    height: 4px;\n    width: 32px;\n  }\n\n  .kot-player-result__step.active {\n    width: 48px;\n  }\n\n  .kot-player-result__body {\n    padding: 0 14px;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    justify-content: flex-start;\n  }\n\n  .kot-player-result__instruction {\n    font-size: 14px;\n    margin: 0 0 10px;\n  }\n\n  .kot-player-result__vs-container {\n    margin-bottom: 8px;\n    gap: 8px;\n  }\n\n  .kot-player-result__card {\n    min-height: 72px;\n    padding: 10px 8px;\n    border-radius: 14px;\n    border-width: 2px;\n  }\n\n  .kot-player-result__card-icon {\n    height: 28px;\n    margin-bottom: 6px;\n  }\n\n  .kot-player-result__card-icon svg {\n    font-size: 28px;\n  }\n\n  .kot-player-result__card-name {\n    font-size: 13px;\n  }\n\n  .kot-player-result__vs-badge {\n    width: 32px;\n    height: 32px;\n    font-size: 11px;\n    border-width: 3px;\n  }\n\n  .kot-player-result__score-input {\n    gap: 10px;\n    margin-bottom: 10px;\n  }\n\n  .kot-player-result__score-btn {\n    width: 52px;\n    height: 52px;\n    border-radius: 14px;\n  }\n\n  .kot-player-result__score-btn svg {\n    font-size: 26px;\n  }\n\n  .kot-player-result__score-display {\n    width: 72px;\n  }\n\n  .kot-player-result__score-value {\n    font-size: 44px;\n  }\n\n  .kot-player-result__score-label {\n    font-size: 11px;\n  }\n\n  .kot-player-result__summary {\n    padding: 8px 10px;\n    margin-bottom: 8px;\n    gap: 8px;\n    border-radius: 12px;\n  }\n\n  .kot-player-result__summary-player {\n    font-size: 13px;\n    gap: 6px;\n  }\n\n  .kot-player-result__summary-player .score {\n    font-size: 18px;\n    padding: 2px 8px;\n  }\n\n  .kot-player-result__summary-divider {\n    font-size: 18px;\n  }\n\n  .kot-player-result__golden-point {\n    padding: 10px 12px;\n    margin-bottom: 8px;\n    font-size: 13px;\n    border-radius: 12px;\n  }\n\n  .kot-player-result__golden-point svg {\n    font-size: 22px;\n  }\n\n  .kot-player-result__error {\n    padding: 10px;\n    margin-bottom: 8px;\n    font-size: 13px;\n  }\n\n  .kot-player-result__footer {\n    padding: 10px 14px;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  .kot-player-result__btn-back,\n  .kot-player-result__btn-submit {\n    padding: 12px;\n    font-size: 14px;\n    border-radius: 12px;\n  }\n\n  .kot-player-result__close {\n    top: 8px;\n    right: 8px;\n    width: 34px;\n    height: 34px;\n  }\n\n  .kot-player-result__close svg {\n    font-size: 20px;\n  }\n}\n\n@media (orientation: landscape) and (max-height: 420px) {\n  .kot-player-result__sheet {\n    max-height: calc(100dvh - 8px);\n  }\n\n  .kot-player-result__instruction {\n    font-size: 12px;\n    margin-bottom: 6px;\n  }\n\n  .kot-player-result__card {\n    min-height: 58px;\n    padding: 8px 6px;\n  }\n\n  .kot-player-result__card-name {\n    font-size: 12px;\n  }\n\n  .kot-player-result__score-btn {\n    width: 44px;\n    height: 44px;\n  }\n\n  .kot-player-result__score-value {\n    font-size: 36px;\n  }\n\n  .kot-player-result__footer {\n    padding: 8px 12px;\n  }\n\n  .kot-player-result__btn-back,\n  .kot-player-result__btn-submit {\n    padding: 10px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
